<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="list-wp" *ngIf="viewData && !isBuzy">
  <div class="search-input-wp">
    <rx-search [(ngModel)]="searchKey" placeholder="Search thumbnail"></rx-search>
  </div>

  <div class="list-content" *ngIf="viewData.length > 0">
    <div class="group-list-item" *ngFor="let group of viewData | search: searchKey : 'folder'">
      <div class="folder-wp" (click)="expandToggle(group.id)">
        <rx-icon name="icon-folder"></rx-icon>
        <div class="folder-name">{{ group.procedureName }}</div>
        <div class="expand-arrow" [ngClass]="{ expanded: expandedIndex === group.id }"></div>
      </div>
      <div class="item-list-wp" *ngIf="expandedIndex === group.id">
        <div
          class="list-item"
          *ngFor="let image of group.images; let idx = index"
          (click)="onSelectImage(image, group.folder)"
          [ngClass]="{ active: selectedData | existItemInList: image : 'image' }"
          [ngStyle]="{ backgroundImage: getImgPath(group.folder, image) }"
        >
          <rx-checkbox
            [id]="'exist-item-' + idx"
            [checked]="selectedData | existItemInList: image : 'image'"
          ></rx-checkbox>
          <div
            class="sub-label-item-wp"
            *ngIf="selectedData | getObjectByKeyFromArrayPipe: image : 'image' as imgSelected"
          >
            <div class="sub-label-item" *ngIf="imgSelected?.subLabel">
              {{ imgSelected.subLabel }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="spinner-wp" *ngIf="isBuzy">
  <rx-icon name="icon-spinner"></rx-icon>
</div>
